var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmarkRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_2985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.870323 6.84473C0.431151 6.40556 0.431151 5.69301 0.870323 5.25379C1.3095 4.81457 2.02204 4.81462 2.46126 5.25379L8.00001 10.8338L13.5781 5.25567C14.0173 4.81649 14.7299 4.81649 15.1691 5.25567C15.6083 5.69484 15.6082 6.40739 15.1691 6.84661L9.58907 12.4229L15.1706 18.0432C15.6098 18.4823 15.6098 19.1949 15.1706 19.6341C14.7314 20.0733 14.0189 20.0733 13.5797 19.6341L8.00001 14.0119L2.42189 19.59C1.98271 20.0292 1.27017 20.0292 0.830949 19.59C0.39173 19.1509 0.391777 18.4383 0.830949 17.9991L6.41095 12.4229L0.870323 6.84473Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_2985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 24,
    fill: "white",
    transform: "matrix(-1 0 0 -1 15.5 24.4229)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkRegular);
export default __webpack_public_path__ + "static/media/xmark-regular.e7173050d25450fb476d32a94315f3c0.svg";
export { ForwardRef as ReactComponent };